import api from '@/services/Api';

class TechnicalAreas {
  static get() {
    return api.get('/public/technical-areas');
  }
}

export default TechnicalAreas;
